module.exports = __webpack_public_path__ + "img/square-y.20e5d39e.svg";